<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">403</h1>
          <h4 class="pt-3">Unauthorized.</h4>
          <p class="text-muted">You do not have permission to view this page. Please contact you administrator if you think this is in error.</p>
        </div>
      </div>
    </div>
  </div>
</div>
